import { Maybe } from 'types/graphqlTypes'
import { isDigitalOption } from 'apps/marketplace/utils/helpers/isDigitalOption'
import { TCarrierOptionSchema } from '../schema/CarrierOptionSchema'
import { ICarrierOption } from '../types'
import { getCarrierAutocompleteOptionText } from './getCarrierAutocompleteOptionText'

export const getCarrierOptionSchema = (
  carrierOption: Maybe<ICarrierOption>
): TCarrierOptionSchema => {
  const {
    amount,
    carrierApplication,
    carrierContactName,
    carrierContactPhone,
    carrierContactPhoneExt,
    carrierContactUserId,
    counterBid,
    createdBy,
    source,
  } = carrierOption || {}
  const { dotNumber = null, id: carrierId = null, mcNumber = null, name = null } =
    carrierApplication || {}
  const { fullName: createdByName, id: createdById } = createdBy || {}
  const { amount: counterOfferAmount = null, status: counterOfferStatus } = counterBid || {}
  const isCounterOfferDeclined = counterOfferStatus === 'Declined'
  const isDigital = isDigitalOption(source)

  const dispatcherId = isDigital && !carrierContactUserId ? createdById : carrierContactUserId
  const dispatcherName = isDigital && !carrierContactName ? createdByName : carrierContactName

  return {
    carrierApplication: carrierApplication
      ? {
          id: carrierId,
          text: getCarrierAutocompleteOptionText(carrierApplication),
          name,
          mcNumber,
          dotNumber,
        }
      : null,
    carrierContactName: dispatcherName || '',
    carrierContactPhone: carrierContactPhone || '',
    carrierContactPhoneExt: carrierContactPhoneExt || '',
    carrierContactUserId: dispatcherId || '',
    amount: amount || null,
    counterOfferAmount: !isCounterOfferDeclined ? counterOfferAmount : null,
    note: '',
    sourceChannel: null,
    sourceSegment: null,
    nonBookable: false,
    getApproval: false,
  }
}
